var React = require('react');

function LocationIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20 10c0 4.418-8 12-8 12s-8-7.582-8-12a8 8 0 1116 0z","fill":"none","stroke":"currentColor","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M12 11a1 1 0 100-2 1 1 0 000 2z","fill":"#000000","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

LocationIcon.defaultProps = {"preserveAspectRatio":"xMinYMin meet","strokeWidth":"1.5","viewBox":"0 0 24 24","fill":"none","color":"currentColor"};

module.exports = LocationIcon;

LocationIcon.default = LocationIcon;
